import React from 'react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcelo G.',
  location: 'Buenos Aires · Empresa de Servicios',
  quote: 'Armé la estructura de mi empresa en un fin de semana. El Tomo de Arquitectura de Poder me hizo ver todo lo que estaba haciendo mal.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Córdoba · PyME Comercial',
  quote: 'El sistema de reuniones del Tomo 4 eliminó el 60% de las interrupciones que tenía por día. Por fin puedo pensar.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Rosario · Empresa de Distribución',
  quote: 'Finanzas de Guerra me salvó la caja en el peor mes del año. Detecté una fuga que no estaba viendo.'
}];
const painPoints = ['Lunes que empieza con 40 mensajes sin resolver porque nadie sabe qué decidir sin vos', 'Reuniones largas, sin agenda, sin decisiones y sin que nadie las lidere', 'Equipo que trabaja pero no produce los resultados que necesitás', 'Caja que no cierra aunque vendiste bien ese mes', 'Vos tomando todas las decisiones: las grandes, las medianas y las que no deberían llegar a vos nunca', 'Fin de semana agotado pensando en la empresa y el lunes volvés a empezar el mismo ciclo'];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#1F1A17]" data-id="element-121">
      <div className="max-w-6xl mx-auto px-4" data-id="element-122">
        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-20 md:mb-28" data-id="element-123">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 rounded-2xl p-6 hover:border-emerald-500/30 transition-colors" data-id="element-124">
              <div className="flex items-center gap-3 mb-4" data-id="element-125">
                <div className="w-11 h-11 rounded-full bg-emerald-500/10 text-emerald-500 flex items-center justify-center font-bold text-sm border border-emerald-500/20" data-id="element-126">
                  {t.initials}
                </div>
                <div data-id="element-127">
                  <div className="text-emerald-500 text-xs tracking-wider mb-0.5" data-id="element-128">
                    ★★★★★
                  </div>
                  <div className="text-sm text-gray-400 font-medium" data-id="element-129">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 italic leading-relaxed text-sm md:text-base" data-id="element-130">
                "{t.quote}"
              </p>
              <div className="mt-4 text-xs text-gray-600 font-medium" data-id="element-131">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12" data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-133">
            ¿Cuántos lunes más vas a llegar así a tu empresa?
          </h2>
          <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-134">
            Sos dueño de PyME. Construiste algo tuyo. Pero nadie te dijo que
            ibas a pasar los domingos pensando en lo que no cerraste, los lunes
            resolviendo lo que el equipo no pudo solo y los viernes sintiendo
            que trabajaste 60 horas para que la empresa no retroceda.
          </p>
          <p className="text-lg md:text-xl text-emerald-500 font-semibold mt-6" data-id="element-135">
            No es falta de esfuerzo. Es falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-gray-900/60 border border-gray-800 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-136">
          <div className="space-y-5" data-id="element-137">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 md:gap-4" data-id="element-138">
                <span className="text-red-500 text-lg mt-0.5 shrink-0" data-id="element-139">❌</span>
                <p className="text-base md:text-lg text-gray-300" data-id="element-140">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12 md:mt-16" data-id="element-141">
          <h3 className="text-2xl md:text-4xl font-bold text-white" data-id="element-142">
            ¿Y si este fuera el último lunes que empezás así?
          </h3>
        </div>
      </div>
    </section>;
}